/* eslint-disable no-undef */
export function openPrivallyModal() {
  if (typeof oPrivallyApp !== 'undefined' && oPrivallyApp !== null)
    oPrivallyApp.openModal('cookie');
}

export const removePrivallyOptionBar = () => {
  const elem = document.getElementById('oPrivallyApp-OptionBar');
  if (elem) {
    elem.setAttribute('style', 'display:none !important');
  } else {
    setTimeout(() => {
      removePrivallyOptionBar();
    }, 500);
  }
};
